export const SpecialSymbols = {
  EmptyDash: "\u2013",
  RankDash: " - ",
  SeparateDot: "\u30FB",
  Space: "\u2423"
};
